"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _RawButton = require("../../RawButton");

var _RawButton2 = _interopRequireDefault(_RawButton);

require("./Tab.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tab = function (_PureComponent) {
  _inherits(Tab, _PureComponent);

  function Tab() {
    _classCallCheck(this, Tab);

    return _possibleConstructorReturn(this, (Tab.__proto__ || Object.getPrototypeOf(Tab)).apply(this, arguments));
  }

  _createClass(Tab, [{
    key: "render",
    value: function render() {
      var cn = (0, _classnames2.default)("aclui-tab", "aclui-tabs__button", { "is-active": this.props.isActive }, { "is-disabled": this.props.isDisabled }, this.props.className);

      if (this.props.children) {
        //This is for use with react-router
        return _react2.default.createElement(
          "span",
          { className: cn },
          this.props.children
        );
      }

      var onClick = this.props.isDisabled ? function () {} : this.props.onClick;
      var tabIndex = this.props.isDisabled ? -1 : 0;

      return _react2.default.createElement(
        _RawButton2.default,
        { "aria-selected": this.props.isActive, className: cn, onClick: onClick, role: "tab", tabIndex: tabIndex },
        this.props.label
      );
    }
  }]);

  return Tab;
}(_react.PureComponent);

Tab.propTypes = {
  children: function children(props, propName, componentName) {
    if (props.children && props.label) {
      return new Error("In '" + componentName + "', use one of 'children' or 'label' props, but not both.");
    }

    if (!props.children && !props.label) {
      return new Error("In '" + componentName + "', supply one of 'children' or 'label' props.");
    }

    return null;
  },
  className: _propTypes.string,
  label: _propTypes.node,
  isActive: _propTypes.bool,
  isDisabled: _propTypes.bool,
  onClick: _propTypes.func
};

Tab.defaultProps = {
  children: null,
  className: null,
  isActive: false,
  isDisabled: false,
  label: null,
  onClick: function onClick() {}
};

exports.default = Tab;